import React from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles'
import { useNavigate } from 'react-router-dom';
import { Stack, TextField, Typography, Card, CardContent, CardMedia, CardActions,
  FormControlLabel, Checkbox, Snackbar, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { ColorModeContext } from '../../contexts'
import { PostRegister } from '../../utils/apiManager'
import { setUserId } from '../../store/features/userSlice'

export default function LoginForm() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const theme = useTheme()
  const colorMode = React.useContext(ColorModeContext)

  const [username, setUserName] = React.useState('')
  const [userfirstname, setUserFirstName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [doNotShareInfoChecked, setDoNotShareInfoChecked] = React.useState(false)
  const [openSnackbar, setOpenSnackbar] = React.useState(false)
  const [snackbarMessage, setSnackbarMessage] = React.useState('')
  const [snackbarSeverity, setSnackBarSeverity] = React.useState(null)

  const handleCloseSnackbar = (event, reason) => {
    setOpenSnackbar(false)
  }

  const handleShareInfoChange = (event) => {
    setDoNotShareInfoChecked(event.target.checked)
  }

  // eslint-disable-next-line
  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log({
      username,
      userfirstname,
      email
    })
    if (!doNotShareInfoChecked) {
      if(username.length > 0 && userfirstname.length > 0 && email.length > 0) {
        PostRegister(username, userfirstname, email).then((response) => {
          dispatch(setUserId(response.user_id))
        }).catch((e) => {
          console.log(e)
        }).finally(() => {
          navigate("/viewer")
        })
      } else {
        setSnackbarMessage('Veuillez remplir tous les champs avant de vous connecter')
        setSnackBarSeverity('error')
        setOpenSnackbar(true)
      }
    } else {
      navigate("/viewer")
    }
  }
  
  React.useEffect(() => {
    dispatch(setUserId(null))
    if (theme.palette.mode === 'dark') {
      colorMode.toggleColorMode()
    }
  }, [])

  return (
    <Card sx={{ maxWidth: 445, width:450, height:730 }}>
      <CardMedia
        component="img"
        height="100"
        image="/ICON_app.png"
        alt="logo"
        sx = {{objectFit: "contain", paddingY: 1}}
      />
      <CardContent>
        <Stack spacing={3}>
          <Typography variant="h6" gutterBottom>
            Connexion à VisioGame :
          </Typography>
          <TextField name="name" label={"Nom" + (!doNotShareInfoChecked ? "*" : "")} onChange={(e)=>setUserName(e.target.value)} />
          <TextField name="firstname" label={"Prénom" + (!doNotShareInfoChecked ? "*" : "")} onChange={(e)=>setUserFirstName(e.target.value)} />
          <TextField name="email" label={"Adresse email" + (!doNotShareInfoChecked ? "*" : "")} onChange={(e)=>setEmail(e.target.value)} />
          
          <FormControlLabel control={<Checkbox checked={doNotShareInfoChecked} onChange={handleShareInfoChange} size="small"/>} 
          label={<Typography style={{fontSize: '12px' }}>Je ne souhaite pas recevoir par mail les informations commerciales de VitaDx</Typography>}
          />
        </Stack>

        <CardActions sx={{display:'flex', justifyContent:"center"}}>
          <LoadingButton size="large" type="submit" variant="contained" onClick={handleSubmit}>
            connexion
          </LoadingButton>
        </CardActions>

        <Typography style={{fontSize: '10px', paddingTop: '15px' }}>Les informations recueillies sont traitées par VitaDx pour gérer votre participation au jeu et, sauf opposition de votre part, vous informer sur les produits et services de VitaDx. Ces traitements sont fondés sur notre intérêt légitime à promouvoir nos activités auprès du public professionnel auxquels elles s’adressent. Vos données ne sont destinées qu’à nos équipes en charge des activités de marketing et de communication et à nos prestataires techniques. Elles sont conservées pendant une durée maximale de 3 ans après notre dernier contact avec vous. Vous disposez du droit d’accéder à vos données, de les rectifier et d’en demander l’effacement, ainsi que de vous opposer ou de limiter leur traitement. Vous pouvez exercer ces droits en vous adressant à notre DPO à l’adresse dpo@vitadx.com ou par courrier postal à l’adresse 74F rue de Paris, 35000 RENNES. Si vous n’êtes pas satisfait de la gestion de votre demande, vous disposez également du droit d’introduire une réclamation auprès de la CNIL.</Typography>

        {!doNotShareInfoChecked &&
          <Typography style={{fontSize: '10px', paddingTop: '5px' }}>* = champs obligatoire</Typography>
        }

      </CardContent>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}>
        <Alert  variant='filled' onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>         
      </Snackbar>
    </Card>
  )
}